import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { environment } from "../../../environments/environment";
import { CmsService } from 'src/app/Services/cms.service';

@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  standalone: false
})

export class SearchPageComponent implements OnInit{
  searchParameter: string = '';
  showResults: boolean = false;
  searchForm: FormGroup = new FormGroup({
    text: new FormControl('')
  });
  searchReady: boolean = false;

  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;

  search_content: string = 'linhas-pesquisa';
  searchInfo: any = {};

  faq_content: string = 'linhas-faq-perguntas'
  faqInfo: any[] = [];

  news_content_name: string = 'linhas-news-list';
  newsList: any[] = [];

  warnings_content_name: string = 'linhas-avisos-alertas';
  warningsList: any[] = [];

  about_content: string = 'linhas-sobre-no';
  aboutInfo: {} = {};

  tresRios_content: string = 'linhas-tres-rio';
  tresRiosInfo: any = {};
  cartoes_tresRios_content: string = 'linhas-lista-cartoes-tres-rios';
  cardsInfoShow: any[] = [];

  fares_list_content: string = 'linhas-lista-tarifarios'
  faresList: any[] = [];

  discounts_content: string = 'linhas-desconto';
  discountsInfo: any[] = [];

  fullList: any[] = [];
  fullListSize: number = 0;
  fullListShow: any[] = []

  constructor(
    private cmsService: CmsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private location: Location,
    private translate: TranslateService,
    private title: Title
  ) {
    this.activatedRoute.queryParams
    .subscribe(queryParams => {
      if(queryParams['search'] != undefined){
        this.searchParameter = queryParams['search'];
        this.searchForm.get('text')?.setValue(this.searchParameter, {emit: false});
      } else {
        this.router.navigate(['/'])
      }
    })
    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];

    this.translate.get('navLinks').pipe().subscribe(trans => {
      let pageTitle =  trans['linhas'] + ' | ' + trans['pesquisa']
      this.title.setTitle(pageTitle);
    })
  }

  ngOnInit(){
    this.getContent()
    this.onChanges()
    this.getSearchContent()
  }

  getContent(){
    this.cmsService.getContentList(this.search_content, this.language).subscribe(
      {
        next: data => {
          this.searchInfo = data['body']['data'];
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  onChanges(){
    this.searchForm.get('text')?.valueChanges.subscribe(
      val => {
        this.search(val.toLowerCase())
      }
    )
  }

  getSearchContent(){
    this.getSobreNos()
  }

  getSobreNos(){
    this.aboutInfo = [];
    this.cmsService.getContentList(this.about_content, this.language).subscribe(
      {
        next: data => {
          this.aboutInfo = data['body']['data'];

          let tempList: any[] = []

          let item = {
            documentId: data['body']['data']['id'],
            group: null,
            title: data['body']['data']['Subtitulo_Seccao'],
            text: data['body']['data']['Texto_Seccao'],
            alert_type: null,
            municipalities: null,
            lines: null,
            date: null
          }
          
          tempList.push(item)

          let result = {
            origin: 'sobreNos',
            results: tempList
          }

          this.fullList.push(result)
          
          this.getTresRios()
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  getTresRios(){
    this.cmsService.getContentList(this.tresRios_content, this.language).subscribe(
      {
        next: data => {
          this.tresRiosInfo = data['body']['data'];

          let tempList: any[] = []

          let item = {
            documentId: data['body']['data']['id'],
            group: null,
            title: data['body']['data']['Titulo_Pagina'],
            text: data['body']['data']['Descricao_Cartoes_Tres_Rios'],
            alert_type: null,
            municipalities: null,
            lines: null,
            date: null
          }
          
          tempList.push(item)

          this.getTresRiosCards(tempList);
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  getTresRiosCards(tempList: any[]){
    this.cmsService.getContentList(this.cartoes_tresRios_content, this.language).subscribe(
      {
        next: data => {
          this.cardsInfoShow =  data['body']['data'];

          this.cardsInfoShow.sort((a,b) => (a.Ordem > b.Ordem) ? 1 : -1 );

          this.cardsInfoShow.forEach(element => {

            element.Questoes.forEach((element : any) => {
              let item = {
                documentId: element.id,
                group: null,
                title: element.Titulo,
                text: element.Conteudo,
                alert_type: null,
                municipalities: null,
                lines: null,
                date: null
              }
              tempList.push(item)
            });
          });
          
          let result = {
            origin: 'tresRios',
            results: tempList
          }

          this.fullList.push(result)

          this.getTarifariosCards();
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  getTarifariosCards(){
    this.cmsService.getContentList(this.fares_list_content, this.language).subscribe(
      {
        next: data => {
          this.faresList = data['body']['data'];

          this.faresList.sort((a,b) => (a.Ordem > b.Ordem) ? 1 : -1 );

          let tempList: any[] = []

          this.faresList.forEach(element => {

            let item = {
              documentId: element.id,
              group: null,
              title: element.Tipo_Tarifario,
              text: element.Texto_Tipo_Tarifario,
              alert_type: null,
              municipalities: null,
              lines: null,
              date: null
            }

            tempList.push(item)
            
            element.Tarifarios.forEach((element : any) => {
              let item = {
                documentId: element.id,
                group: null,
                title: element.Nome,
                text: element.Descricao,
                alert_type: null,
                municipalities: null,
                lines: null,
                date: element.Preco
              }
              
              tempList.push(item)
            });

          });
          
          let result = {
            origin: 'tarifarios',
            results: tempList
          }

          this.fullList.push(result)

          this.getDescontos();

        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  getDescontos(){
    this.cmsService.getContentList(this.discounts_content, this.language).subscribe(
      {
        next: data => {
          this.discountsInfo = data['body']['data']['Descontos'];

          let tempList: any[] = []

          this.discountsInfo.forEach(element => {
            let item = {
              documentId: element.id,
              group: null,
              title: element.Titulo,
              text: element.Conteudo,
              alert_type: null,
              municipalities: null,
              lines: null,
              date: null
            }
            tempList.push(item)
          });

          let result = {
            origin: 'descontos',
            results: tempList
          }

          this.fullList.push(result)
          
          this.getNews()
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  getNews(){
    this.newsList = [];
    this.cmsService.getContentList(this.news_content_name, this.language).subscribe(
      {
        next: data => {
          this.newsList = data['body']['data'];

          this.newsList.sort((a,b) => (a.Data > b.Data) ? -1 : 1 );

          let tempList: any[] = []

          this.newsList.forEach(element => {
            let item = {
              documentId: element.documentId,
              group: null,
              title: element.Titulo,
              text: element.Texto,
              alert_type: null,
              municipalities: null,
              lines: null,
              date: element.Data
            }
            tempList.push(item)
          });

          let result = {
            origin: 'news',
            results: tempList
          }

          this.fullList.push(result)

          this.getWarnings()

        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  getWarnings(){
    this.warningsList = [];
    this.cmsService.getContentList(this.warnings_content_name, this.language).subscribe(
      {
        next: data => {

          this.warningsList = data['body']['data'];

          this.warningsList.sort((a, b) => (a.Inicio > b.Inicio) ? 1 : -1 );

          let tempList: any[] = []

          this.warningsList.forEach(element => {
            let item = {
              documentId: element.documentId,
              group: null,
              title: element.Titulo,
              text: element.Texto,
              alert_type: element.Tipo.TipoAlerta,
              municipalities: element.Municipios.map((item: any) => item.Municipio).join(", "),
              lines: element.Linhas,
              date: element.Inicio
            }
            tempList.push(item)
          });

          let result = {
            origin: 'warnings',
            results: tempList
          }

          this.fullList.push(result)

          this.getFaq();

        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  getFaq(){
    this.faqInfo = []
    this.cmsService.getContentList(this.faq_content, this.language).subscribe(
      {
        next: data => {
          this.faqInfo = data['body']['data'];

          this.faqInfo.sort((a,b) => (a.Ordem > b.Ordem) ? 1 : -1 );

          let tempList: any[] = []

          this.faqInfo.forEach(element => {
            let groupname = element.Grupo
            let questions = element.Perguntas
            questions.forEach((element: any) => {
              let item = {
                documentId: element.id,
                group: groupname,
                title: element.Pergunta,
                text: element.Resposta,
                alert_type: null,
                municipalities: null,
                lines: null,
                date: null
              }
              tempList.push(item)
            });

          });

          let result = {
            origin: 'faq',
            results: tempList
          }

          this.fullList.push(result)

          this.fullListShow = this.fullList;

          this.fullListSize = this.fullListShow.length;

          this.searchForm.get('text')?.setValue(this.searchParameter);

        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  search(text: string){
    this.searchParameter = text;
    if(text == ''){
      this.fullListShow = this.fullList
    } else {
      this.fullListShow = this.fullList
      .map(item => ({
        ...item,
        results: item.results.filter((res: any) =>
          (res.title != null && res.title.toLowerCase().includes(text)) ||
          (res.text != null && res.text.toLowerCase().includes(text)) ||
          (res.municipalities != null && res.municipalities.toLowerCase().includes(text)) ||
          (res.lines != null && res.lines.toLowerCase().includes(text))
        )
      }))
      .filter(item => item.results.length > 0);
    }

    this.fullListSize = this.fullListShow.length;

    this.updateUrlParam('search', text)

    this.searchReady = true;
  }

  updateUrlParam(key: string, value: string) {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set(key, value);

    this.location.replaceState(currentUrl.pathname + currentUrl.search);
  }

  goToNews(id: string){
    this.router.navigate(['/noticias-detalhe'], { queryParams: { id: id } });
  }

  highlightText(text: string): string {
    if (!this.searchParameter) return text;

    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');
    const escapedSearch = this.searchParameter.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const searchRegex = new RegExp(`(${escapedSearch})`, 'gi');

    function highlightNodes(node: Node) {
      if (node.nodeType === Node.TEXT_NODE) {
        const replaced = node.nodeValue?.replace(searchRegex, '<span class="highlight">$1</span>');
        if (replaced !== node.nodeValue) {
          const wrapper = document.createElement('span');
          wrapper.innerHTML = replaced || '';
          node.parentNode?.replaceChild(wrapper, node);
        }
      } else {
        node.childNodes.forEach(highlightNodes);
      }
    }

    highlightNodes(doc.body);

    return doc.body.innerHTML;
  }

}
